/**
 * Generisches Accordion. 1:1 Verhalten aus design-preview/index.html <script>.
 *
 * Markup:
 *   <button data-accordion-toggle aria-controls="panel-id" aria-expanded="false">
 *   <div id="panel-id" class="hidden"> ... </div>
 *
 * Chevron-Rotation wird rein CSS-seitig per
 *   [data-accordion-toggle][aria-expanded="true"] .mob-chevron { transform: rotate(180deg); }
 * gesteuert (siehe main.css).
 */
export function initAccordion(): void {
    document.querySelectorAll<HTMLButtonElement>('[data-accordion-toggle]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
            const targetId = toggle.getAttribute('aria-controls')
            if (!targetId) return

            const target = document.getElementById(targetId)
            if (!target) return

            const isOpen = toggle.getAttribute('aria-expanded') === 'true'
            toggle.setAttribute('aria-expanded', String(!isOpen))
            target.classList.toggle('hidden')
        })
    })
}
